import React from 'react';
import ajax from '../../ajax';
import functions from '../../functions';
import DashCard from '../Common/DashCard';


class TotalSupervisors extends React.Component {
  
  state={
    userId:functions.sessionGuard(),
    value:'...'
  }
  async componentDidMount()
  {
    await this.requestRecord();
    this.timer = setTimeout(this.func=async()=> {
      await this.requestRecord();
      this.timer = setTimeout(this.func, 2000); // (*)
    }, 2000);
  }

  componentWillUnmount()
  {
    clearTimeout(this.timer)
  }

  requestRecord=async()=>{
    const server_response=await ajax.countSupervisors();
    if(server_response.status==="OK")
    {
      this.setState({
        value:server_response.details.total_p
      })
    }
  }

  render(){
    
      return (
        <DashCard 
            title="Agent Supervisors"
            value={this.state.value}
            caption="Total Supervisors"
            icon={"fas fa-dove text-success"}
            />

      );
    
 
  }
}

export default TotalSupervisors;